import { render } from "./UzhnetSelect.vue?vue&type=template&id=22426044"
import script from "./UzhnetSelect.vue?vue&type=script&lang=js"
export * from "./UzhnetSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__